import React, { useEffect, useState } from "react";
import { getEventsinner } from "../Service/Api";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";
const Events = () => {
  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState();
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [monthOptions, setMonthOptions] = useState(["All"]);
  const [yearRanges, setYearRanges] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const Year = `${currentYear}`;
    setSelectedYear(Year);
    console.log("get current Year", Year);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const galleryData = await getEventsinner();
      setData(galleryData);

      const uniqueYears = Array.from(
        new Set(
          galleryData.flatMap((item) => {
            if (item.date) {
              const year = new Date(item.date).getFullYear();
              return [year];
            } else {
              return [];
            }
          }),
        ),
      );
      const uniqueYearRanges = uniqueYears.map((year) => `${year}`);
      uniqueYearRanges.sort((a, b) => b - a);
      setYearRanges(uniqueYearRanges);

      const uniqueMonths = Array.from(
        new Set(
          galleryData.flatMap((item) => {
            if (item.date) {
              const month = new Date(item.date).getMonth();
              return [month];
            } else {
              return [];
            }
          }),
        ),
      );
      const monthOptions = uniqueMonths
        .sort((a, b) => a - b)
        .map((month) => monthNames[month]);
      setMonthOptions(["All", ...monthOptions]);
    };
    fetchData();
  }, []);

  useEffect(() => {
    let filteredData = data;
    if (selectedYear !== "All") {
      filteredData = filteredData.filter((item) => {
        if (item.date && item.date.trim() !== "") {
          const year = new Date(item.date).getFullYear();
          const month = new Date(item.date).getMonth();
          return (
            parseInt(selectedYear) === year &&
            (selectedMonth === "All" || monthNames[month] === selectedMonth)
          );
        } else {
          return false;
        }
      });
    }
    if (selectedMonth !== "All") {
      filteredData = filteredData.filter((item) => {
        if (item.date && item.date.trim() !== "") {
          const month = new Date(item.date).getMonth();
          return monthNames[month] === selectedMonth;
        } else {
          return false;
        }
      });
    }
    if (searchQuery) {
      filteredData = filteredData.filter((item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase()),
      );
    }
    // Sort the filtered data by date in descending order
    //   filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));
    setFilteredData(filteredData);
  }, [selectedYear, selectedMonth, searchQuery, data]);
  const emptyArray = [
    {
      description:
        "“Educating the mind without educating the heart is no education at all.” Sacred Heart has been educating boys and girls since 1990; though much has changed over the years our mission remains the same. Sacred Heart is committed to developing students of high academic achievement, intellectual curiosity, and strong moral character. As a result, year after year Sacred Heart sends our respectful, responsible and compassionate young adults, who are well prepared to tackle the challenges that lay ahead. Since arriving at Sacred Heart in 2016, I have had the opportunity to observe this unique institution up close. I have seen its commitment to academic excellence, its dynamic student body, and incredibly committed faculty and a loving community where the students and families are proud and supportive of one another. As I walk down the hallways of the school every day, I can hear the chatter of eager minds; the shouts of excitement from the victorious athletes, the thumb of dancers feed and the sound of melodious voices harmonizing the perpetual energy, movement and enthusiasm permeate the atmosphere. Ours is a school with difference. We value creativity and innovation and strive to nurture them in our students. Sacred Heartians are groomed to become confident, articulate and enlightened young citizens ready to step into the global society with dignity, honour and integrity. Aristotle once said “Educating the mind without educating the heart is no education at all”. Even as we impart education to match the advancement in technology and globalization, we march our children ahead with Sacred Heart ethos of moral values and principles. We Endeavour constantly to instill these qualities in our children. We pride ourselves to help them grow and develop into sensitive, responsible God loving citizens of the future. May the Sacred Heart of Jesus bless us abundantly in all our endeavourers.",
      attachments: ["director.jpg"],
    },
  ];
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Events </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Events </h1>
            </div>
          </div>
          <div className="row tabs-dynamic">
            <div className="col-md-3">
              <div className="count-val">
                <p>Total Count: {filterData.length}</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="month-selection">
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  className="yearSelection"
                >
                  <option value={"All"}>All</option>

                  {yearRanges.map((yr) => (
                    <option key={yr} value={yr}>
                      {yr}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-3">
              <div className="month-selection">
                <select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  className="monthSelect"
                >
                  {monthOptions.map((month, index) => (
                    <option key={index} value={month}>
                      {month}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-3">
              <div className="searchBox">
                <input
                  type="text"
                  id="myInput"
                  name="name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search Here.."
                />
              </div>
            </div>
          </div>
          <div className="row years year2023 showYear">
            {filterData.length > 0
              ? filterData.map((item, index) => (
                  <div
                    className="col-xl-3 col-lg-4 col-md-6 col-sm-12 eventCount"
                    key={index}
                  >
                    <div className="event-blk">
                      <div className="event-img">
                        <LazyLoad
                          offset={10}
                          placeholder={
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/event.jpg"
                              alt="Loading..."
                              className="img-fluid"
                            />
                          }
                        >
                          <img
                            src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.images}`}
                            alt="Gandhi High School, Sidhi, MP"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <div className="event-date">
                          <h3>{item.date} </h3>
                        </div>
                        <div className="event-time">
                          <p>
                            <i className="bi bi-calendar3"></i> {item.time}{" "}
                          </p>
                        </div>
                      </div>
                      <div className="event-content">
                        <h3>{item.title} </h3>
                        <p>{item.description} </p>
                      </div>
                      <div className="landmark">
                        <p>
                          {" "}
                          <span>Location : </span> {item.venue}{" "}
                        </p>
                      </div>
                      {item.attachments && item.attachments.length > 0 && (
                        <div className="attachment">
                          <Link
                            to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments}`}
                            target="_blank"
                          >
                            <i className="bi bi-paperclip"></i>
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                ))
              : emptyArray.map((data, index) => (
                  <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 eventCount">
                    <div className="event-blk">
                      <div className="event-img">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/event.jpg"
                          alt="Gandhi High School, Sidhi, MP"
                          className="img-fluid"
                        />
                        <div className="event-date">
                          <h3>
                            14 <span>Jan</span>
                          </h3>
                        </div>
                        <div className="event-time">
                          <p>
                            <i className="bi bi-calendar3"></i> 08:00 AM
                          </p>
                        </div>
                      </div>
                      <div className="event-content">
                        <h3>Event Heading</h3>
                        <p>Event Description</p>
                      </div>
                      <div className="landmark">
                        <p>
                          <Link to="#" target="_blank">
                            <span>Location : </span> School Campus
                          </Link>
                        </p>
                      </div>
                      <div className="attachment">
                        <Link to="#" target="_blank">
                          <i className="bi bi-paperclip"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
            {/* <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 eventCount">
           <div className="event-blk">
               
               <div className="event-img">
                   <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/event.jpg" alt="Gandhi High School, Sidhi, MP" className="img-fluid" />
               <div className="event-date">
                   <h3>14 <span>Sep</span></h3>
               </div>
               <div className="event-time">
                       <p><i className="bi bi-calendar3"></i> 08:00 AM</p>
                   </div>
               </div>
               <div className="event-content">
                   <h3>Event Heading</h3>
                   <p>Event Description</p>
               </div>
               <div className="landmark">
                   <p><Link to="#" target="_blank"><span>Location : </span> School Campus</Link></p>
                   
               </div>
               <div className="attachment">
                   <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
               </div>
           </div>
       </div>
       <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 eventCount">
           <div className="event-blk">
               
               <div className="event-img">
                   <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/event.jpg" alt="Gandhi High School, Sidhi, MP" className="img-fluid" />
               <div className="event-date">
                   <h3>15 <span>Sep</span></h3>
               </div>
               <div className="event-time">
                       <p><i className="bi bi-calendar3"></i> 08:00 AM</p>
                   </div>
               </div>
               <div className="event-content">
                   <h3>Event Heading</h3>
                   <p>Event Description</p>
               </div>
               <div className="landmark">
                   <p><Link to="#" target="_blank"><span>Location : </span> School Campus</Link></p>
                   
               </div>
               <div className="attachment">
                   <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
               </div>
           </div>

       </div>
       <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 eventCount">
           <div className="event-blk">
               
               <div className="event-img">
                   <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/event.jpg" alt="Gandhi High School, Sidhi, MP" className="img-fluid" />
               <div className="event-date">
                   <h3>14 <span>Oct</span></h3>
               </div>
               <div className="event-time">
                       <p><i className="bi bi-calendar3"></i> 08:00 AM</p>
                   </div>
               </div>
               <div className="event-content">
                   <h3>Event Heading</h3>
                   <p>Event Description</p>
               </div>
               <div className="landmark">
                   <p><Link to="#" target="_blank"><span>Location : </span> School Campus</Link></p>
                   
               </div>
               <div className="attachment">
                   <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
               </div>
           </div>

       </div>
       <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 eventCount">
           <div className="event-blk">
               
               <div className="event-img">
                   <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/event.jpg" alt="Gandhi High School, Sidhi, MP" className="img-fluid" />
               <div className="event-date">
                   <h3>14 <span>Apr</span></h3>
               </div>
               <div className="event-time">
                       <p><i className="bi bi-calendar3"></i> 08:00 AM</p>
                   </div>
               </div>
               <div className="event-content">
                   <h3>Event Heading</h3>
                   <p>Event Description</p>
               </div>
               <div className="landmark">
                   <p><Link to="#" target="_blank"><span>Location : </span> School Campus</Link></p>
                   
               </div>
               <div className="attachment">
                   <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
               </div>
           </div>
       </div>
       <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 eventCount">
           <div className="event-blk">
               
               <div className="event-img">
                   <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/event.jpg" alt="Gandhi High School, Sidhi, MP" className="img-fluid" />
               <div className="event-date">
                   <h3>14 <span>Apr</span></h3>
               </div>
               <div className="event-time">
                       <p><i className="bi bi-calendar3"></i> 08:00 AM</p>
                   </div>
               </div>
               <div className="event-content">
                   <h3>Event Heading</h3>
                   <p>Event Description</p>
               </div>
               <div className="landmark">
                   <p><Link to="#" target="_blank"><span>Location : </span> School Campus</Link></p>
                   
               </div>
               <div className="attachment">
                   <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
               </div>
           </div>
       </div>
       <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 eventCount">
           <div className="event-blk">
               
               <div className="event-img">
                   <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/event.jpg" alt="Gandhi High School, Sidhi, MP" className="img-fluid" />
               <div className="event-date">
                   <h3>07 <span>Apr</span></h3>
               </div>
               <div className="event-time">
                       <p><i className="bi bi-calendar3"></i> 08:00 AM</p>
                   </div>
               </div>
               <div className="event-content">
                   <h3>Event Heading</h3>
                   <p>Event Description</p>
               </div>
               <div className="landmark">
                   <p><Link to="#" target="_blank"><span>Location : </span> School Campus</Link></p>
                    
               </div>
               <div className="attachment">
                   <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
               </div>
           </div>
       </div>
       <div className="load-more">
           <div className="next">Show More</div>
       </div> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Events;
